import { api } from 'services/api';

interface BarrelForecastPrams {
  userId: string;
  deviceId: string;
}

export interface BarrelForecastResponse {
  deviceId: string;
  uzd: number;
  barrelDistance: number;
  barrelSize: string;
  barrelVolume: number;
  remains: number;
  forecastConsumptionLiters: number;
  endOfDayRemainsPercent: number;
}

const forecastApi = api
  .enhanceEndpoints({
    addTagTypes: ['FORECAST'],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getBarrelsForecast: build.query<
        BarrelForecastResponse,
        BarrelForecastPrams
      >({
        query: (params) => ({
          url: '/forecast/barrel',
          method: 'GET',
          params,
        }),
        providesTags: (_res, _err, params) => [
          {
            type: 'FORECAST',
            id: params.deviceId,
          },
        ],
      }),
    }),
  });

export const { useGetBarrelsForecastQuery } = forecastApi;
